type ChipColors = 'green' | 'blue' | 'red';

export const getColorChip = (value: number): ChipColors => {
    if (value < 5) return 'red';
    if (value < 8) return 'blue';

    return 'green';
};
